import QuotaDashboard from '@/contexts/quota-dashboard/domain/quota-dashboard'
import QuotaDashboardRepository from '@/contexts/quota-dashboard/infrastructure/quota-dashboard.repository'

export default class GetQuotaList {
  private readonly repository: QuotaDashboardRepository

  constructor(repository: QuotaDashboardRepository) {
    this.repository = repository
  }

  async execute(distributorId: number): Promise<QuotaDashboard[]> {
    if (!distributorId) throw new Error('Cooperative id is undefined')
    return this.repository.getQuota(distributorId)
  }
}
